import PerfilMenuPage from './pages/PerfilMenuPage.vue'
import PerfilMenuAssociacaoPage from './pages/PerfilMenuAssociacaoPage.vue'

const routes = [
  {
    path: 'perfis-menus',
    name: 'perfis-menus',
    component: PerfilMenuPage
  },
  {
    path: 'perfis-menus/:usuario',
    name: 'perfis-menus-associacao',
    component: PerfilMenuAssociacaoPage
  }
];

export default routes;